<div>
  <ng-container *ngIf="!hidePaymentStatus">
    <div [tooltip]="paymentStatusMap[statusId].tooltipText"
      placement="left"
      container="body">
      {{ status }}
    </div>
    <small *ngIf="!!subStatus">
      ({{ paymentSubStatusMap[subStatus].translated }})
    </small>
  </ng-container>
  <ng-container *ngIf="hidePaymentStatus">
    {{ alternatePaymentStatusText || '' }}
  </ng-container>
  <ng-container *ngIf="isArchived">
    (<yc-i18n
      key="GLOBAL:textArchivedLowercase"
      defaultValue="archived">
    </yc-i18n>)
  </ng-container>
  <small class="d-block">
    {{ statusDate | ycStartOfDayDateFormatter }}
  </small>
  
  <!-- Address Request Status -->
  <gc-address-request-status-display *ngIf="!isForApplicantPortal"
    [isClientProcessed]="processor === ProcessingTypes.Client"
    [hasAddressRequest]="!!payeeOverride?.address1"
    [addressRequestStatus]="payeeOverride?.addressRequestStatus"
    [paymentStatus]="statusId">
  </gc-address-request-status-display>

</div>